var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 상세정보 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState, curSchduleTreeState } from "../../../../recoil/assessmentState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { dailyState, infoPop, reLoad, reloadRight, reLoadState, userInfoLoginState, } from "../../../../recoil/userState";
// utils
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import { useDebounceEffect } from "./DaysMain";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
import { langId, langState } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
function DailyInfoTodayCheck(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const curTree = useRecoilValue(curSchduleTreeState);
    const [itemId, setitemId] = useRecoilState(dailyState);
    const [infoPopId, setInfoPopId] = useRecoilState(infoPop);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reroadRights, setReroadRights] = useRecoilState(reloadRight);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const langs = useRecoilValue(langState); // 다국어
    const langIds = useRecoilValue(langId);
    // useState
    const [checkItemList, setCheckItemList] = useState(null);
    const [checkOpen, setCheckOpen] = useState(false);
    const [checkEctOpen, setCheckEctOpen] = useState(false);
    const [checkEdit, setCheckEdit] = useState(null);
    const [checkChange, setCheckChange] = useState(false);
    const [editReload, setEditReload] = useState(false);
    // props
    const { handleOpenPop, itemInfo } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
        if (window.outerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    function CheckListOpen(e) {
        e.preventDefault();
        if (!checkOpen) {
            setCheckOpen(true);
        }
        else {
            setCheckOpen(false);
        }
    }
    useEffect(() => {
        //진단 점검 수중
        handleOpenPop("pop-check-edit", _jsx(ChechItemUpdatepop, { isMobile: isMobile, curTree: curTree, checkEdit: checkEdit, checkChange: checkChange, setCheckEdit: setCheckEdit, setCheckChange: setCheckChange, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => EditClose("pop-check-edit") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkEdit: checkEdit }));
    }, []);
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/schedule/${itemId.scheduleId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: itemId.itemId + reroadRights + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum === CONST.API_200) {
                setCheckItemList(data.body);
            }
            else {
            }
        }
    }, [data, reroadRights, langIds]);
    // 상세 정보 닫기
    function closePopup(id) {
        const infoPop = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.add("m-hidden");
            infoPop.classList.remove("popup-layer");
            infoPop.classList.remove("js-layer");
            infoPop.classList.remove("popup-type1");
            infoPop.removeAttribute("style");
            if (!CUTIL.isnull(body))
                body.removeAttribute("style");
            if (!CUTIL.isnull(dimm))
                dimm.removeAttribute("style");
            setInfoPopId("");
            return;
        }
    }
    // 진단 점검 하기 수정 삭제 레이어 팝업
    function typeBox(item) {
        // type_class.classList.toggle("open");
        if (!checkEctOpen) {
            setCheckEctOpen(true);
            //
            setCheckChange(true);
        }
        else {
            setCheckEctOpen(false);
            setCheckChange(false);
        }
    }
    // 수정, 삭제 팝업
    function EditClose(id) {
        CUTIL.jsclose_Popup(id);
        setCheckChange(false);
        setCheckEdit(null);
    }
    // 삭제 수정 레이블 팝업
    function CheckPop(e, item) {
        setCheckEdit(item);
        setCheckEctOpen(false);
        CUTIL.jsopen_Popup(e);
    }
    // 진단 점검
    function CheckOn(e) {
        return __awaiter(this, void 0, void 0, function* () {
            closePopup(infoPopId);
            setCheck(Object.assign(Object.assign({}, check), { checkType: "daily", checkOn: true, nextStep: "step3", itemInfo: {
                    id: itemId.id,
                    itemId: itemId.itemId,
                    itemName: itemInfo.panelName,
                    panelName: itemInfo.panelName,
                    serialNo: itemInfo.serialNo,
                    spgId: itemInfo.companySpgId,
                }, chekVersionTypeInfo: {
                    checkVersionId: checkItemList.checkVersionId,
                    versionNo: checkItemList.checkVersionNo,
                }, dueDate: checkItemList.dueDate, schdeulerId: checkItemList.scheduleId, inspector: checkItemList.inspector, disabled: true }));
        });
    }
    // 수정 삭제 레이블 이외 다른곳 클릭 이벤트
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("btn-etc") || targetElement.closest(".btn-etc");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".popup-etc");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
                setCheckEctOpen(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("section", { children: [_jsxs("div", Object.assign({ className: "section-top" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.진단점검") })), _jsxs("div", Object.assign({ className: "color-info" }, { children: [_jsx("p", Object.assign({ className: "ehc" }, { children: t("스케쥴.캘린더.LS") })), _jsx("p", Object.assign({ className: "etc" }, { children: t("스케쥴.캘린더.고객향점검") }))] }))] })), checkItemList ? (_jsxs("div", Object.assign({ className: `section-bottom box-shadow ${checkItemList.checkTypeName.split(" ", 1) == "LS" ? "ehc" : checkItemList.checkTypeName.split(" ", 1) == "직무고시" ? "jig" : "etc"}` }, { children: [_jsxs("div", Object.assign({ className: "title" }, { children: [_jsxs("a", Object.assign({ href: "#", className: "click", onClick: (e) => CheckListOpen(e) }, { children: [_jsx("p", Object.assign({ className: "m-none" }, { children: checkItemList.checkTypeName })), _jsx("p", Object.assign({ className: "date" }, { children: checkItemList.dueDate }))] })), _jsx("button", Object.assign({ type: "button", className: "btn", onClick: (e) => CheckOn(e) }, { children: _jsx("span", { children: t("라벨.점검하기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-etc", onClick: (e) => typeBox(checkItemList) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815/\uC0AD\uC81C \uC120\uD0DD \uB808\uC774\uC5B4\uD31D\uC5C5" })) })), _jsxs("ul", Object.assign({ className: `popup-etc  ${checkEctOpen ? "open" : ""}` }, { children: [_jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-edit-g js-open", "data-pop": "pop-check-edit", onClick: (e) => CheckPop(e, checkItemList) }, { children: _jsx("span", { children: t("라벨.수정") }) })) }), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => CheckPop(e, checkItemList) }, { children: _jsx("span", { children: t("라벨.삭제") }) })) })] }))] })), _jsxs("ul", Object.assign({ className: `cont ${checkOpen ? "open" : ""}` }, { children: [_jsxs("li", { children: [_jsxs("p", { children: [_jsx("span", { children: t("라벨.점검유형") }), _jsx("span", { children: checkItemList.checkTypeName ? checkItemList.checkTypeName : "-" })] }), _jsxs("p", { children: [_jsx("span", { children: t("라벨.상세유형") }), _jsx("span", { children: checkItemList.checkSubTypeName ? checkItemList.checkSubTypeName : "-" })] }), _jsxs("p", { children: [_jsx("span", { children: t("라벨.버전") }), _jsx("span", { children: checkItemList.checkVersionNo ? checkItemList.checkVersionNo : "-" })] })] }), _jsx("li", { children: _jsxs("p", { children: [_jsx("span", { children: t("라벨.점검자") }), _jsx("span", { children: checkItemList.inspector ? checkItemList.inspector : "-" })] }) }), _jsx("li", { children: _jsxs("p", { children: [_jsx("span", { children: t("라벨.점검메모") }), _jsx("span", { children: checkItemList.memo ? checkItemList.memo : "-" })] }) })] }))] }))) : (
                // {/*<!--230425, 진단점검 없는 경우-->*/}
                _jsx("div", Object.assign({ className: "section-bottom box-shadow no-data" }, { children: _jsxs("div", Object.assign({ className: "title" }, { children: [_jsx("a", Object.assign({ href: "#", className: "click", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: "\uC608\uC815\uB41C \uC810\uAC80 \uC77C\uC815\uC774 \uC5C6\uC2B5\uB2C8\uB2E4." }) })), _jsxs("div", Object.assign({ className: "flex-inline right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn" }, { children: _jsx("span", { children: t("라벨.지금점검하기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn" }, { children: _jsx("span", { children: t("라벨.일정추가하기") }) }))] }))] })) })))] }) }));
}
export default DailyInfoTodayCheck;
function ChechItemUpdatepop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const itemId = useRecoilValue(dailyState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reroadRights, setReroadRights] = useRecoilState(reloadRight);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    const langs = useRecoilValue(langState);
    // props
    const { curTree, checkEdit, setCheckEdit, checkChange, setCheckChange, isMobile } = props;
    // useState
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [checkTypeBoolean, setCheckTypeBoolean] = useState(false);
    const [subCheckTypeBoolean, setSubCheckTypeBoolean] = useState(false);
    const [checkType, setCheckType] = useState("");
    const [subCheckType, setSubCheckType] = useState("");
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        checkVersionId: -1,
        isOutSource: false,
        period: null,
        inspector: "",
        scheduleId: -1,
    });
    const [memo, setMemo] = useState("");
    // 체크리스트 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktypes?companySpgId=${itemId.spgId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: checkEdit + reload + reroadRights + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChecktypeItem(data.body);
                setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: checkEdit ? checkEdit.inspector : "", scheduleId: checkEdit ? checkEdit.scheduleId : "", period: checkEdit ? checkEdit.period : "" }));
                setMemo(checkEdit ? checkEdit.memo : "");
                setToday(new Date(checkEdit && checkEdit.dueDate));
                if (checkEdit) {
                    let types = null;
                    data.body.filter((cf) => cf.description === checkEdit.checkTypeName).map((type) => (types = type));
                    CheckTypeSub(types, false);
                    setCheckType(types.description);
                }
            }
            else {
                // need error handle
                /*    setAlert({
                     ...alert,
                     type: CONST.TYPE_NONE,
                     divTag: data.errorList.map((err) => (err.msg))
                   });
                   CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
            }
        }
    }, [data, checkEdit, checkChange, langIds]);
    // 상세 유형
    function CheckTypeSub(type, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            // 진단 유형 초기화
            if (!boolean) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        if (checkEdit) {
                            let types = null;
                            data.body.filter((cf) => cf.checkSubName === checkEdit.checkSubTypeName).map((type) => (types = type));
                            CheckTypeVersion(types, false);
                            setSubCheckType(types.checkSubName);
                        }
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                if (checkType !== type.checkTypeName) {
                    setCheckTypeBoolean(false);
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "GET",
                        appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setCheckSubtypeItem(data.body);
                            setCheckType(type.checkTypeName);
                            setCheckTypeBoolean(true);
                            setCheckVersiontypeItem([]);
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    setCheckType(type.checkTypeName);
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (!boolean) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        if (checkEdit) {
                            let types = null;
                            data.body.filter((cf) => cf.versionNo === checkEdit.checkVersionNo).map((type) => (types = type));
                            CheckTypeVersionSel(types);
                        }
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                if (subCheckType !== type.checkSubName) {
                    setSubCheckTypeBoolean(false);
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "GET",
                        appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setCheckVersiontypeItem(data.body);
                            setSubCheckType(type.checkSubName);
                            setSubCheckTypeBoolean(true);
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    setSubCheckType(type.checkSubName);
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: type.checkVersionId }));
        });
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    function onChangInspector(e) {
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: e.target.value }));
    }
    function SchdeulerEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/schedule/${schduleAdd.scheduleId}`,
                appQuery: {
                    dueDate: dayjs(today).format("YYYYMMDD"),
                    checkVersionId: schduleAdd.checkVersionId,
                    isOutSource: !schduleAdd.isOutSource,
                    period: schduleAdd.period,
                    inspector: schduleAdd.inspector,
                    memo: memo,
                    completionDate: null,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReroadRights(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정이완료되었습니다") }));
                    EditClose("pop-check-edit");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReroadRights(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function EditClose(id) {
        CUTIL.jsclose_Popup(id);
        setCheckChange(false);
        setCheckTypeBoolean(false);
        setSubCheckTypeBoolean(false);
        setCheckEdit(null);
    }
    return (_jsxs(_Fragment, { children: [checkChange && (_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName + " " + curTree.subZone.subZoneName }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") }), _jsx("li", { children: curTree.spg.spgBoolean ? curTree.spg.spgName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.진단설정") }), _jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_type", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkEdit ? checkEdit.checkTypeName : t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                checkTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type, true) }, { children: type.description }), "type_Check" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star` }, { children: t("라벨.상세유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_subtype", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkTypeBoolean ? t("라벨.클릭선택") : checkEdit && checkEdit.checkSubTypeName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type, true) }, { children: type.checkSubName }), "subtype_Check" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ` }, { children: t("라벨.버전") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_ver", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkVersionTypeItem.length <= 0 || subCheckTypeBoolean
                                                                        ? t("라벨.클릭선택")
                                                                        : checkEdit && checkEdit.checkVersionNo })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "version_Check" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검예정일") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: today, onChange: (date) => setToday(date), 
                                                    // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                    withPortal: isMobile ? true : false, 
                                                    // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                    placeholderText: t("라벨.점검예정일선택") }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.자동점검주기") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_auto", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkEdit &&
                                                                        automaticCheckCycle
                                                                            .filter((accf) => accf.value == checkEdit.period)
                                                                            .map((acc) => acc.cycleNo) })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_Check" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검자") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp3", placeholder: t("라벨.텍스트입력"), value: schduleAdd.inspector, onChange: (e) => onChangInspector(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] }))] }))] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => EditClose("pop-check-edit") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SchdeulerEdit(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { checkEdit } = props;
    function scheduleDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/schedule/${checkEdit.scheduleId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                setRecoilIsLoadingBox(false);
                setReload(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.진단점검일정을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            scheduleDelete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
